import * as React from 'react'
const RightSideIcon = (props) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.16602 7.00002H12.8327M12.8327 7.00002L6.99935 1.16669M12.8327 7.00002L6.99935 12.8334"
      stroke="#344054"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default RightSideIcon
